<zuper-drawer class="border-l border-gray-300 shadow-none color-profile-create-form" [name]="drawerName" [mode]="'over'"
    [position]="'right'" [transparentOverlay]="false" (openedChanged)="drawerOpenedChanged($event)"
    [hideOnClickOutside]="false" [fixed]="true">
    <div class="drawer-content w-full relative" *ngIf="openDrawer">
        <div class="main-container">
            <!-- Empty state -->
            <div class="w-full main-container relative primary-font text-base text-gray-700 font-normal"
                *ngIf="state === ColorProfileState.Empty">
                <!-- Header -->
                <div>
                    <div class="relative w-full p-4 bg-white z-0 border-b">
                        <div class="flex items-center justify-between w-full">
                            <h5 class="font-semibold text-xl">
                                {{'color_profile.empty_state.title' | translate}}
                            </h5>
                            <div class="flex items-center">
                                <i (click)="closeDrawer()"
                                    class="ti ti-x text-2xl ml-3 p-1.5 hover:bg-gray-200 rounded-full"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-4 w-full absolute top-1/4 space-y-4">
                    <div class="w-full flex justify-center text-gray-500">{{'color_profile.empty_state.subtitle_one' | translate}}</div>
                    <div class="border rounded-lg bg-gray-100 p-4 relative flex items-center">
                        <div class="w-fit min-w-fit flex flex-col space-y-2 relative">
                            <span class="text-xl leading-7 font-semibold">{{'color_profile.empty_state.title' | translate | titlecase}}</span>
                            <span class="leading-6 text-gray-500">{{'color_profile.empty_state.select_label' | translate}}</span>
                            <ng-select #colorProfileModule class="w-48 cursor-pointer static"
                                [(ngModel)]="newColorProfileModule" [searchable]="false" [clearable]="false"
                                [multiple]="false" [hideSelected]="true" [appendTo]="parent"
                                (change)="colorProfileModule.blur(); createNewColorProfileChange();">
                                <ng-option [value]="'ALL'">{{'color_profile.empty_state.customize_for' | translate}}</ng-option>
                                <ng-option *ngFor="let module of colorModules" [value]="module">{{module |
                                    titlecase}}</ng-option>
                            </ng-select>
                        </div>
                        <div class="relative">
                            <img src="/assets/images/svgs/color_profile_empty_state.svg" alt="" loading="eager">
                        </div>
                    </div>
                </div>
                <div class="absolute bottom-0 space-y-4 w-full">
                    <div class="w-full flex justify-center text-gray-500">{{'color_profile.empty_state.subtitle_two' | translate}}</div>
                    <div class="w-full shadow-sm primary-font font-normal text-base border-t py-4 px-2 bg-white">
                        <div class="w-full px-4 flex justify-end items-center gap-4 h-full">
                            <button type="button" (click)="closeDrawer()"
                                class="px-6 items-center py-2 border border-gray-300 shadow-sm rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none">
                                {{'close.text' | translate}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Listing -->
            <div class="w-full main-container relative primary-font text-base text-gray-700 font-normal"
                *ngIf="state === ColorProfileState.Listing">
                <!-- Header -->
                <div>
                    <div class="relative w-full p-4 bg-white z-0 border-b">
                        <div class="flex items-center justify-between w-full">
                            <h5 class="font-semibold text-xl">
                                {{'color_profile.listing.title' | translate}}
                            </h5>
                            <div class="flex items-center">
                                <i (click)="closeDrawer()"
                                    class="ti ti-x text-2xl ml-3 p-1.5 hover:bg-gray-200 rounded-full"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-4 bg-gray-100 flex items-center space-x-2">
                    <i class="ti ti-info-circle text-2xl"></i>
                    <span class="font-medium">{{'color_profile.listing.header_note' | translate}}</span>
                </div>
                <div class="p-4 primary-font text-gray-700 font-normal text-base flex flex-col space-y-6 listing-container overflow-y-auto zuper-scrollbar">
                    <div class="flex flex-col" *ngFor="let module of colorModules"
                        [ngClass]="colorProfiles?.[module]?.length ? 'space-y-4': ''">
                        <!-- Module Heading -->
                        <div class="flex justify-between items-center">
                            <span class="font-semibold text-xl">{{module| titlecase}}</span>
                            <button class="flex items-center add-color-profile border cursor-pointer hover:bg-gray-100"
                                (click)="openCreateOrUpdateColorProfile(module, 'CREATE')">
                                <i class="ti ti-plus text-2xl text-gray-500"></i>
                                <span class="font-medium">{{'add.text' | translate}}</span>
                            </button>
                        </div>
                        <div *ngIf="isLoading[module]">
                            <div class="flex flex-col space-y-2 mt-4">
                                <zuper-shimmer-loading  width="100%" height="35px" ></zuper-shimmer-loading>
                                <zuper-shimmer-loading  width="100%" height="35px" ></zuper-shimmer-loading>
                            </div>
                        </div>
                        <div *ngIf="!isLoading[module]">
                            <div *ngIf="!colorProfiles?.[module]?.length && listingEmptyState[module]">
                                <span class="text-gray-500">{{listingEmptyState[module]}}</span>
                            </div>
                            <div id="section-{{module}}" class="space-y-4 profile-list" cdkDropList
                                (cdkDropListDropped)="drop($event, module)">
                                <div class="border rounded-lg bg-white shadow-sm p-2 profile-item" cdkDrag
                                    cdkDragBoundary="#section-{{module}}"
                                    *ngFor="let profile of colorProfiles?.[module]; trackBy: colorProfileListTrackBy">
                                    <div class="flex items-center justify-between">
                                        <div class="flex space-x-3 items-center truncate">
                                            <div class="flex-0 cursor-move" cdkDragHandle>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                    viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" stroke-width="2"
                                                    stroke-linecap="round" stroke-linejoin="round"
                                                    class="icon icon-tabler icons-tabler-outline icon-tabler-grip-horizontal">
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                    <path d="M5 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                                                    <path d="M5 15m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                                                    <path d="M12 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                                                    <path d="M12 15m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                                                    <path d="M19 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                                                    <path d="M19 15m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
                                                </svg>
                                            </div>
                                            <div class="flex-0 rounded-md w-9 h-9 flex items-center justify-center min-w-fit"
                                                [style.background]="profile?.color">
                                                <i class="ti text-2xl cursor-default" [ngClass]="profile?.icon"
                                                    [style.color]="profile?.iconTextColor"></i>
                                            </div>
                                            <span class="font-medium block truncate flex-1"
                                                title="{{profile?.name}}">{{profile?.name}}</span>
                                        </div>
                                        <div class="flex space-x-4 items-center">
                                            <span class="text-red-500 text-base font-medium cursor-pointer hover:underline"
                                                (click)="deleteColorProfile(profile)">{{'delete.text' | translate}}</span>
                                            <span class="text-blue text-base font-medium cursor-pointer hover:underline"
                                                (click)="openCreateOrUpdateColorProfile(module, ColorProfileState.Update, profile)">{{'edit' | translate}}</span>
                                            <div class="w-0.5 h-6 bg-gray-200"></div>
                                            <div class="min-w-fit custom-slide-toggle flex items-center space-x-2">
                                                <mat-slide-toggle #listingColorProfileToggleState [disableRipple]="true" [disbaled]="disableToggleState" [checked]="profile?.is_active"
                                                    [color]="'primary'" (change)="updateColorProfileStateInListing(module, listingColorProfileToggleState?.checked, profile)">
                                                </mat-slide-toggle>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="w-full absolute bottom-0 z-999 shadow-sm primary-font font-normal text-base border-t py-4 px-2 bg-white">
                    <div class="w-full px-4 flex justify-end items-center gap-4 h-full">
                        <button type="button" (click)="closeDrawer()"
                            class="px-6 items-center py-2 border border-gray-300 shadow-sm rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none">
                            {{'close.text' | translate}}
                        </button>
                    </div>
                </div>
            </div>

            <!-- Create and Edit -->
            <div class="w-full main-container relative primary-font text-base text-gray-700 font-normal"
                *ngIf="state === ColorProfileState.Create || state === ColorProfileState.Update">
                <!-- Header -->
                <div>
                    <div class="relative w-full p-4 bg-white z-0 border-b">
                        <div class="flex items-center justify-between w-full">
                            <div class="flex items-center primary-font text-base font-normal text-gray-700">
                                <i class="ti ti-arrow-left text-2xl mr-4" (click)="navigateBackFromCreate()"></i>
                                <div class="flex items-center">
                                    <span
                                        [ngClass]="state === ColorProfileState.Create ? 'font-medium': ''">{{selectedModule
                                        | titlecase}}</span>
                                    <div class="flex items-center" *ngIf="state === ColorProfileState.Update">
                                        <i class="ti ti-slash text-2xl"></i>
                                        <span class="font-semibold">{{colorProfileForm.value?.name ||''}}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="flex items-center">
                                <i (click)="closeDrawer()"
                                    class="ti ti-x text-2xl ml-3 p-1.5 hover:bg-gray-200 rounded-full"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-4 bg-gray-100 flex items-center space-x-2 note-banner" *ngIf="showNoteBannerInCreatePage">
                    <i class="ti ti-info-circle text-2xl"></i>
                    <span class="font-medium">{{'color_profile.create.header_note' | translate}}</span>
                </div>
                <div class="primary-font text-gray-700 font-normal text-base flex flex-col space-y-4"
                    [formGroup]="colorProfileForm">
                    <div class="flex space-x-4 px-4 pt-4"
                        [ngClass]="colorProfileForm.controls?.name?.errors?.required && colorProfileForm.controls?.name?.touched ? 'items-start': 'items-center'">
                        <!-- Icon and Color -->
                        <div class="flex flex-col justify-center items-start space-y-1">
                            <span class="text-gray-500 font-medium">{{'color_profile.create.label.icon' | translate}}</span>
                            <div class="border rounded-md h-fit w-fit border-gray-300"
                                [tippyProps]="iconColorSelectorTippyProps" [ngxTippy]="iconColorSelectorTemplate">
                                <div class="h-8 w-8 color-icon flex items-center justify-center rounded"
                                    [style.background]="colorProfileForm.value?.color">
                                    <i class="ti text-2xl" [ngClass]="colorProfileForm.value?.icon"
                                        [style.color]="iconTextColor"></i>
                                </div>
                            </div>
                        </div>
                        <!-- Name -->
                        <div class="flex flex-col justify-center items-start space-y-1 w-full">
                            <div class="flex items-center space-x-1">
                                <span class="text-gray-500 font-medium">{{'name.text' | translate}}</span>
                                <span class="mandatory-field">*</span>
                            </div>
                            <input type="text" autocomplete="off" required formControlName="name"
                                [ngClass]="colorProfileForm.controls?.name?.errors?.required && colorProfileForm.controls?.name?.touched || colorProfileForm.controls?.name?.errors?.maxlength ? 'border-red-600': 'focus:border-indigo-500'"
                                class="block w-full rounded-md border border-gray-300 bg-white px-4 py-3 leading-none text-base"
                                placeholder="Color Profile Name">
                            <p class="text-red-500 text-base mt-1"
                                *ngIf="colorProfileForm.controls?.name?.errors?.required && colorProfileForm.controls?.name?.touched">
                                {{'text.field_is_required'| translate}}</p>
                        </div>
                    </div>
                    <div class="flex items-center space-x-4 px-4">
                        <span class="font-medium cursor-pointer" (click)="enableColorProfileBtn.toggle()">{{'color_profile.create.label.enable' | translate}}</span>
                        <div class="min-w-fit custom-slide-toggle flex items-center space-x-2">
                            <mat-slide-toggle #enableColorProfileBtn [disableRipple]="true" formControlName="isEnabled"
                                [color]="'primary'"></mat-slide-toggle>
                        </div>
                    </div>
                    <div class="w-full h-0.5 bg-gray-200"></div>
                    <div class="flex flex-col" *ngIf="filterFieldOptions?.length && !filterDataLoading">
                        <div class="p-1 border rounded mx-4 w-fit px-1.5 shadow">{{'color_profile.create.label.apply_when' | translate}}</div>
                        <div class="condition-container zuper-scrollbar">
                            <meta-field-selector [options]="filterOptionsConfig"
                                [filterOptionalValues]="filterOptionalValues || []" [hideHeaderFooter]="true"
                                [module]="filterModule"
                                [filterFieldOptions]="filterFieldOptions"
                                (applyOrSaveFilter)="onChangeFilters($event)"></meta-field-selector>
                            <p class="text-red-500 text-base p-4 pt-0"
                                *ngIf="colorProfileForm.controls?.conditions?.errors?.required && colorProfileForm.controls?.conditions?.touched">
                                {{'color_profile.error.add_condition'| translate}}</p>
                        </div>
                    </div>
                    <div class="w-full h-full- items-center flex justify-center" *ngIf="filterDataLoading">
                        <lazy-loader></lazy-loader>
                    </div>
                </div>
                <div
                    class="w-full absolute bottom-0 z-999 shadow-sm primary-font font-normal text-base border-t py-4 px-2 bg-white">
                    <div class="w-full px-4 flex items-center gap-4 h-full"
                        [ngClass]="state === ColorProfileState.Update ? 'justify-between': 'justify-end'">
                        <button type="button" *ngIf="state === ColorProfileState.Update" (click)="deleteColorProfile()"
                            class="px-6 flex items-center space-x-2 py-2 border border-gray-300 shadow-sm rounded-md text-red-600 bg-white hover:bg-gray-50 focus:outline-none">
                            <i class="ti ti-trash text-2xl mb-0.5"></i>
                            <span>{{'delete.text' | translate}}</span>
                        </button>
                        <div class="flex items-center space-x-4">
                            <button type="button" (click)="navigateBackFromCreate()"
                                class="px-6 items-center py-2 border border-gray-300 shadow-sm rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none">
                                {{'cancel.text' | translate}}
                            </button>
                            <button type="button" [disabled]="advanceFilterService?.isFormOpen$ | async"
                                (click)="submitColorProfileForm()"
                                [ngClass]="{'cursor-not-allowed opacity-60': (advanceFilterService?.isFormOpen$ | async)}"
                                class="bg-primary default-hover px-6 items-center py-2 border b-1 border-gray-300 shadow-sm text-white font-small rounded-md text-white-600 focus:outline-none btn-small"
                                type="button">{{(state === ColorProfileState.Create ? 'text.save': 'update') | translate}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</zuper-drawer>

<ng-template let-hide #iconColorSelectorTemplate>
    <div class="w-fit h-fit">
        <!-- Colors Section -->
        <div class="flex flex-col space-y-2 space-x-2 p-4">
            <div class="grid grid-flow-row auto-rows-auto"
                style="grid-template-columns: repeat(8, minmax(3rem, 1fr)); row-gap: 12px;">
                <div *ngFor="let color of iconsAndColors?.colors; trackBy: iconSelectorTrackBy"
                    class="w-8 h-8 flex justify-center items-center rounded-md cursor-pointer border"
                    [style.background]="color"
                    [ngClass]="color === colorProfileForm.value?.color ? 'ring-2 ring-offset-2 ring-gray-400':''"
                    (click)="changeColorAndIcon('color', color)">
                    <i class="ti ti-check text-2xl" *ngIf="color === colorProfileForm.value?.color"
                        [style.color]="iconTextColor"></i>
                </div>
            </div>
        </div>
        <div class="w-full h-0.5 bg-gray-200"></div>
        <!-- Icons Section -->
        <div class="flex flex-col space-y-1 p-4">
            <div class="grid grid-flow-row auto-rows-auto"
                style="grid-template-columns: repeat(8, minmax(3rem, 0fr)); row-gap: 12px;">
                <div *ngFor="let icon of iconsAndColors?.icons; trackBy: iconSelectorTrackBy"
                    class="w-10 h-10 flex justify-center items-center rounded-md cursor-pointer"
                    (click)="changeColorAndIcon('icon', icon)"
                    [ngClass]="{'border': icon === colorProfileForm.value?.icon}"
                    [ngStyle]="{'background-color': icon === colorProfileForm.value?.icon ? colorProfileForm.value?.color : 'white', 'color': icon === colorProfileForm.value?.icon ? iconTextColor : '#6B7280' }">
                    <i class="ti text-3xl" [ngClass]="icon"></i>
                </div>
            </div>
        </div>
    </div>
</ng-template>